type Props = {
  total: number;
  current: number;
  completed: boolean[];
  onJump: (i: number) => void;
};

export function ProgressBar({ total, current, completed, onJump }: Props) {
  return (
    <div className="progress" role="navigation" aria-label="Form progress">
      {Array.from({ length: total }).map((_, i) => {
        const state =
          i === current ? "current" : completed[i] ? "complete" : i < current ? "complete" : "locked";
        const canJump = i < current || completed[i];
        return (
          <button
            key={i}
            type="button"
            data-state={state}
            disabled={!canJump}
            onClick={() => canJump && onJump(i)}
            aria-label={`Step ${i + 1}${state === "current" ? " (current)" : ""}${
              state === "complete" ? " (complete)" : ""
            }`}
            aria-current={state === "current" ? "step" : undefined}
          >
            {i + 1}
          </button>
        );
      })}
    </div>
  );
}
